import React from "react";
import solutionsData from "../../data/aiInEcommerceSolutions.json";

export default function Section3() {
  return (
    <div className="Section3 md:flex px-5 my-[4%] md:p-[2%] justify-evenly items-center md:mb-[3%] md:-mt-[1%]">
      <div className="md:w-[36%]">
        {solutionsData.map(({ title, text }, index) => {
          return (
            <>
              <h2 className="text-[20px] md:text-[25px] font-bold leading-[30px] text-[#DA2128] mt-5 mb-[10px]">{title}</h2>
              <p className="text-[#373737] text-[16px] font-open leading-[20px]">{text}</p>
            </>
          );
        })}
      </div>

      <div>
        <img className="mx-auto w-[80%] md:w-auto" src="/assets/computer-ai-in-ecommerce.png"></img>
      </div>
    </div>
  );
}
